import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=c8caaaf6&scoped=true&"
import script from "./Loading.vue?vue&type=script&lang=js&"
export * from "./Loading.vue?vue&type=script&lang=js&"
import style0 from "@@/core/components/shared/Loading/LoadingStyle.css?vue&type=style&index=0&id=c8caaaf6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8caaaf6",
  null
  
)

export default component.exports